module.exports = __webpack_public_path__ + "static/banner-7-music-world-wide-2d65a225086c7b0de34c47e178971f5b.jpg";